import type { LessonRoomStore, LessonRoomChatMessage } from './interfaces'

export const actions = {
  setBooking (this: LessonRoomStore, payload: LessonRoomStore['booking']): void {
    this.booking = payload
  },
  setLastLesson (this: LessonRoomStore, payload: LessonRoomStore['lastLesson']): void {
    this.lastLesson = payload
  },
  setChatOpen (this: LessonRoomStore, payload: boolean): void {
    if (payload) this.activeOverlay = 'chat'
    else if (this.activeOverlay === 'chat') this.activeOverlay = 'none'
  },
  setChatUnread (this: LessonRoomStore, payload: LessonRoomStore['chatUnread']): void {
    this.chatUnread = payload
  },
  addChatMessage (this: LessonRoomStore, payload: LessonRoomChatMessage): void {
    this.chatMessages = [...this.chatMessages, payload]
  },
  setSettingsOpen (this: LessonRoomStore, payload: boolean): void {
    if (payload) this.activeOverlay = 'settings'
    else if (this.activeOverlay === 'settings') this.activeOverlay = 'none'
  },
  setPermissionsBlocked (this: LessonRoomStore, payload: LessonRoomStore['permissionsBlocked']): void {
    this.permissionsBlocked = payload
  },
  setDeniedMic (this: LessonRoomStore, payload: LessonRoomStore['deniedMic']): void {
    this.deniedMic = payload
  },
  setDeniedCam (this: LessonRoomStore, payload: LessonRoomStore['deniedCam']): void {
    this.deniedCam = payload
  },
  setGuideOpen (this: LessonRoomStore, payload: boolean): void {
    if (payload) this.activeOverlay = 'guide'
    else if (this.activeOverlay === 'guide') this.activeOverlay = 'none'
  },
  setGuideCategory (this: LessonRoomStore, payload: LessonRoomStore['guideCategory']): void {
    this.guideCategory = payload
  },
}
